import React from 'react';
import { Stack, Typography } from '@mui/material';

type HighlightedTextProps = {
  text: string;
  highlight: string;
  extraData?: string[];
};

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  highlight,
  extraData
}) => {
  if (!highlight.trim()) {
    return (
      <Stack sx={{ minWidth: 0, flex: 1 }}>
        <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
          {text}
        </span>
        {extraData && extraData.length > 0 && (
          <Typography
            fontSize="12px"
            fontWeight={500}
            sx={{
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              whiteSpace: 'normal'
            }}
          >
            {extraData.filter(Boolean).join(' | ')}
          </Typography>
        )}
      </Stack>
    );
  }

  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <Stack sx={{ minWidth: 0, flex: 1 }}>
      <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
        {parts.map((part, index) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <strong key={index}>{part}</strong>
          ) : (
            <span key={index}>{part}</span>
          )
        )}
      </span>
      {extraData && extraData.length > 0 && (
        <Typography
          fontSize="12px"
          fontWeight={500}
          sx={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal'
          }}
        >
          {extraData.filter(Boolean).join(' | ')}
        </Typography>
      )}
    </Stack>
  );
};
